import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { eq, or } from 'ember-truth-helpers';

interface PrismRadioGroupInputSignature {
  Args: {
    checkedValue: string;
    disabled?: boolean;
    isSmall?: boolean;
    name: string;
    onChange: (event: Event) => unknown;
    radioGroupDisabled?: boolean;
    value: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLabelElement;
}

const PrismRadioGroupInput: TOC<PrismRadioGroupInputSignature> = <template>
  {{#let (or @disabled @radioGroupDisabled) as |isDisabled|}}
    <label
      class={{concat
        "prism-radio"
        " "
        (if isDisabled "prism-radio--disabled")
        " "
        (if @isSmall "text-200--regular" "text-300--regular")
      }}
      ...attributes
    >
      <input
        checked={{eq @checkedValue @value}}
        data-test-radio-group-input={{@value}}
        disabled={{isDisabled}}
        name={{@name}}
        type="radio"
        value={{@value}}
        {{on "change" @onChange}}
      />
      <span
        class="prism-radio__circle {{if @isSmall 'prism-radio__circle--small'}}"
      />
      <div class="prism-radio__label">
        {{yield}}
      </div>
    </label>
  {{/let}}
</template>;

export default PrismRadioGroupInput;
